import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import RestaurantMenuOutlinedIcon from "@mui/icons-material/RestaurantMenuOutlined";
import Loading from "../UI/Loading";

/** Lista dos cardápios do integral. */
const CardapioTable = ({ cardapios, isLoading, ativando, onSelect, onAtivar }) => {
  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando cardápios..." />
      </Box>
    );
  }

  if (cardapios.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <RestaurantMenuOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhum cardápio cadastrado.
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" aria-label="Cardápios">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Descrição</TableCell>
            <TableCell sx={{ width: 160 }}>Situação</TableCell>
            <TableCell sx={{ width: 48 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {cardapios.map((c) => (
            <TableRow key={c.codigo} hover onClick={() => onSelect(c)} sx={{ cursor: "pointer" }}>
              <TableCell>
                <Typography variant="body2" fontWeight={500}>
                  {c.descricao}
                </Typography>
              </TableCell>
              <TableCell>
                {c.ativo ? (
                  <Chip size="small" color="success" variant="outlined" label="Ativo" />
                ) : (
                  <Button
                    size="small"
                    disabled={ativando !== null}
                    onClick={(event) => {
                      event.stopPropagation();
                      onAtivar(c);
                    }}
                  >
                    {ativando === c.codigo ? "Ativando..." : "Tornar ativo"}
                  </Button>
                )}
              </TableCell>
              <TableCell align="right">
                <ChevronRightIcon fontSize="small" color="action" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CardapioTable;
